<template>
  <div :class="classes">
    <el-input-number  v-model="crrentValue" :controls-position="controlsPosition" @change="handleChange"
    :min="min" :max="max" :step="step" :precision="precision" :controls="controls"
    :placeholde="placeholder" :size="size" @blur="blur" @focus="focus" :disabled="disabled"></el-input-number>
  </div>
</template>

<script>
// 组件class前缀
import { InputNumber } from 'element-ui'
const prefixCls = 'wt-input-number'
export default {
  name: 'wt-input-number',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    controlsPosition: {
      type: String,
      default: ''
    },
    min: {
      type: [Number, String],
      default: -Infinity
    },
    max: {
      type: Number,
      default: Infinity
    },
    step: {
      type: Number,
      default: 1
    },
    precision: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  components: {
    'el-input-number': InputNumber
  },
  data () {
    return {
      crrentValue: this.value
    }
  },
  watch: {
    value (val) {
      this.crrentValue = val
    },
    crrentValue (val) {
      this.$emit('input', val)
    },
    max () {
      if (this.currentValue > this.max) {
        this.currentValue = this.max
      }
    },
    min () {
      if (this.currentValue < this.min) {
        this.currentValue = this.min
      }
    }
  },
  methods: {
    handleChange (val) {
      this.$emit('change', val)
    },
    blur (val) {
      this.$emit('blur', val)
    },
    focus (val) {
      this.$emit('focus', val)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
